/** What will happen to the fee, for staff who can't waive it. */
export const getFeeStatement = ({
  feeLabel,
  feeAmount,
  feeIsKnowable,
  autoChargeCardOnFile,
}: {
  feeLabel: string;
  feeAmount: string | null;
  feeIsKnowable: boolean;
  autoChargeCardOnFile: boolean;
}): string => {
  if (feeAmount) {
    return autoChargeCardOnFile
      ? `The patient will be charged a ${feeAmount} ${feeLabel} on their card on file.`
      : `The patient will be charged a ${feeAmount} ${feeLabel}. It will be added to their balance.`;
  }
  if (feeIsKnowable) return `No ${feeLabel} applies to this appointment.`;
  return autoChargeCardOnFile
    ? `The patient will be charged the ${feeLabel} on their card on file, if one applies.`
    : `The patient will be charged the ${feeLabel}, if one applies. It will be added to their balance.`;
};
